module.exports = __webpack_public_path__ + "img/eng_dhfesta_info_0401.5ce4978a.jpg";